import { IMenuItem } from '../../models/menu.model';

/**
 * Menu configuration for Loss Adjuster Desk.
 * Contains menu items for compliance and infraction management.
 */
export const lossAdjusterMenu: IMenuItem = {
  label: `Loss Adjuster Desk`,
  icon: 'fa fa-user-shield',
  path: 'loss-adjuster-desk',
  children: [
    {
      label: 'Loss Adjuster',
      path: `loss-adjuster`,
      id: 'MID_LOSS_ADJUSTER_DESK_ROOT',
      icon: 'fa fa-user-shield',
    },
    {
      path: 'fees',
      label: 'Fees',
      id: 'MID_LOSS_ADJUSTER_FEES',
      icon: 'fa fa-money-bill-trend-up',
    },
  ],
};
